import { render, staticRenderFns } from "./RestrictedPage.vue?vue&type=template&id=511a89ea&scoped=true&"
import script from "./RestrictedPage.vue?vue&type=script&lang=js&"
export * from "./RestrictedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511a89ea",
  null
  
)

export default component.exports